import {GeneralDataInterface} from "../interfaces/GeneralDataInterface";
import {CompleteReportResultItemInterface} from "../interfaces/CompleteReportResultItemInterface";
import {API, FieldOptions} from "../constants/constants";
import {completeReportResult} from "../api/axxerion";

interface submitNotificationArgs {
    areaNumber: string,
    problemTypeReference: string,
}

export const submitNotificationData = async (args: submitNotificationArgs) => {

    const {areaNumber, problemTypeReference} = args

    const data = {
        "reference": API.FILTER_REFERENCE,
        "filterFields": [FieldOptions.AREA_NUMBER, FieldOptions.PROBLEM_TYPE_SCHEME_REFERENCE, FieldOptions.PROBLEM_TYPE_REFERENCE],
        "filterValues": [areaNumber, API.PROBLEM_TYPE_SCHEME_REFERENCE, problemTypeReference]
    }

    return await completeReportResult(data)
}